import React from "react";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import TermsAndConditionsPageComponents from "../components/page-auth/TermsAndConditionsPageComponents";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        }
    })
);


const TermsAndConditionsPage = () => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.terms-and-conditions")}</title>
                <meta name="description" content={t("page.title.terms-and-conditions")}/>
            </Helmet>

            <div className={classes.root}>
                <AuthenticatedUserLayout pageTitle={t("page.title.terms-and-conditions-header")}>
                    <TermsAndConditionsPageComponents/>
                </AuthenticatedUserLayout>
            </div>
        </AuthorizedContextProvider>
    );
};

export default TermsAndConditionsPage;